import dayjs from 'dayjs';
export var getAvailableTimeSlots = function (timeAvailability, minAdvancePeriod) {
    return timeAvailability.filter(function (timeSlot) {
        return dayjs(timeSlot.start).isAfter(dayjs().add(minAdvancePeriod, 'seconds'));
    });
};
